import * as React from "react";

const SvgManual = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 25 24"
  >
    <mask
      id="manual_svg__a"
      width={25}
      height={24}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="currentColor" d="M.412 0h24v24h-24z" />
    </mask>
    <g mask="url(#manual_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8.512 21.213a9.7 9.7 0 0 0 3.9.787 9.7 9.7 0 0 0 3.9-.788 10.1 10.1 0 0 0 3.175-2.137q1.35-1.35 2.137-3.175a9.7 9.7 0 0 0 .788-3.9 9.7 9.7 0 0 0-.788-3.9 10.1 10.1 0 0 0-2.137-3.175q-1.35-1.35-3.175-2.137a9.7 9.7 0 0 0-3.9-.788 9.7 9.7 0 0 0-3.9.788 10.1 10.1 0 0 0-3.175 2.137Q3.987 6.275 3.199 8.1a9.7 9.7 0 0 0-.787 3.9q0 2.075.787 3.9a10.1 10.1 0 0 0 2.138 3.175q1.35 1.35 3.175 2.137m9.575-3.538Q15.762 20 12.412 20t-5.675-2.325T4.412 12t2.325-5.675Q9.06 4 12.412 4t5.675 2.325T20.412 12t-2.325 5.675M9.614 9.971l1.719 5.601h1.386l1.841-5.59h.044q-.059 1.347-.068 1.66-.005.312-.005.551v3.379h1.411V8.433h-2.06l-1.793 5.46h-.029l-1.69-5.46H8.31v7.139h1.353v-3.32q0-.572-.093-2.28z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default SvgManual;
